
<div class="amplify-amplify-form-row amplify-signin-username">
    <div *ngIf="this._usernameAttributes === 'email'">
        <label class="amplify-input-label" for="emailField"> {{ this.amplifyService.i18n().get('Email') }} *</label>
        <input
            #emailField
            class="amplify-form-input"
            type="email"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            (keyup)="setEmail($event.target.value)"
            data-test="email-input"
        />
    </div>
    <div *ngIf="this._usernameAttributes === 'phone_number'">
        <amplify-auth-phone-field-core
            (phoneFieldChanged)="onPhoneFieldChanged($event)"
        ></amplify-auth-phone-field-core>
    </div>
    <div *ngIf="this._usernameAttributes !== 'email' && this._usernameAttributes !== 'phone_number'">
        <label class="amplify-input-label" for="usernameField"> {{ this.amplifyService.i18n().get(getUsernameLabel()) }} *</label>
        <input
            #usernameField
            class="amplify-form-input"
            type="text"
            value="{{this.username}}"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            (keyup)="setUsername($event.target.value)"
            data-test="username-input"
        />
    </div>
</div>
